import { render, staticRenderFns } from "./TextBlock2.vue?vue&type=template&id=8ed7f070&scoped=true&"
import script from "./TextBlock2.vue?vue&type=script&lang=js&"
export * from "./TextBlock2.vue?vue&type=script&lang=js&"
import style0 from "./TextBlock2.vue?vue&type=style&index=0&id=8ed7f070&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ed7f070",
  null
  
)

export default component.exports